import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { __awaiter, __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useRef, useEffect } from 'react';
import { Loader } from '@finam/web-ui-kit';
import { Root, LoaderWrap, OAuthButton } from './Auth.styles';
import { useLocale } from '../../i18n';
import LoginScreen from '../Login';
import RegistrationScreen from '../Registration';
import QRScreen from '../QR';
import Logo from '../Logo';
var TOOLTIP_WIDTH = 200;
var Route;

(function (Route) {
  Route["Login"] = "login";
  Route["Registration"] = "registration";
  Route["QR"] = "qr";
  Route["OAuthSelect"] = "oAuthSelect";
})(Route || (Route = {}));

var Auth = function Auth(_a) {
  var variant = _a.variant,
      confirmationProp = _a.confirmation,
      lastLoginInfoProp = _a.lastLoginInfo,
      qr = _a.qr,
      registration = _a.registration,
      titleText = _a.title,
      oAuthSources = _a.oAuthSources,
      authProcessor = _a.authProcessor,
      initialNotYourComputer = _a.initialNotYourComputer,
      onResetLastLogin = _a.onResetLastLogin,
      uiSettings = _a.uiSettings,
      registrationData = _a.registrationData,
      props = __rest(_a, ["variant", "confirmation", "lastLoginInfo", "qr", "registration", "title", "oAuthSources", "authProcessor", "initialNotYourComputer", "onResetLastLogin", "uiSettings", "registrationData"]);

  var _useLocale = useLocale(),
      i18n = _useLocale.i18n;

  var _useState = useState(confirmationProp),
      _useState2 = _slicedToArray(_useState, 2),
      confirmation = _useState2[0],
      setConfirmation = _useState2[1];

  var _useState3 = useState((uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.initialRoute) || Route.Login),
      _useState4 = _slicedToArray(_useState3, 2),
      route = _useState4[0],
      setRoute = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      oAuthSource = _useState6[0],
      setOAuthSource = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = useState(lastLoginInfoProp),
      _useState10 = _slicedToArray(_useState9, 2),
      lastLoginInfo = _useState10[0],
      setLastLoginInfo = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      hintTooltip = _useState12[0],
      setHintTooltop = _useState12[1];

  var rootRef = useRef(null);
  var updateHintTooltip = useCallback(function () {
    if (!rootRef.current) {
      return;
    }

    var right = rootRef.current.getBoundingClientRect().right;
    var showTooltips = window.innerWidth - right >= TOOLTIP_WIDTH;
    setHintTooltop(showTooltips);
  }, []);
  useEffect(function () {
    updateHintTooltip();
    window.addEventListener('resize', updateHintTooltip);
    return function () {
      return window.removeEventListener('resize', updateHintTooltip);
    };
  }, [updateHintTooltip]);
  var handleChangeConfirmation = useCallback(function (value) {
    setConfirmation(value);
  }, []);
  var handleGetLogoutAfter = useCallback(function () {
    return authProcessor.getTokenProvider().getLogoutAfter();
  }, [authProcessor]);
  var handleLogin = useCallback(function (req) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return authProcessor.authorize(req);

            case 2:
              res = _context.sent;

              if (!oAuthSource) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return authProcessor.oAuthConnect(oAuthSource);

            case 6:
              return _context.abrupt("return", res);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [oAuthSource, authProcessor]);
  var handleConfirm = useCallback(function (code) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return authProcessor.confirm(code);

            case 2:
              if (!oAuthSource) {
                _context2.next = 5;
                break;
              }

              _context2.next = 5;
              return authProcessor.oAuthConnect(oAuthSource);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }, [oAuthSource, authProcessor]);
  var handleClickOAuth = useCallback(function (source) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _b, res;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              _context3.prev = 1;
              _context3.next = 4;
              return authProcessor.oAuth(source, props.provider.id);

            case 4:
              res = _context3.sent;

              if (!res.success && res.ott) {
                setOAuthSource(source);
                setRoute(Route.OAuthSelect);
              } else if ((_b = res.confirmation) === null || _b === void 0 ? void 0 : _b.enable) {
                setConfirmation(res.confirmation);
              }

            case 6:
              _context3.prev = 6;
              setLoading(false);
              return _context3.finish(6);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1,, 6, 9]]);
    }));
  }, [props.provider.id, authProcessor]);
  var handleClickHasAccount = useCallback(function () {
    return setRoute(Route.Login);
  }, []);
  var handleClickRegistration = useCallback(function () {
    setRoute(Route.Registration);
  }, []);
  var handleResetLastLogin = useCallback(function () {
    setLastLoginInfo(undefined);
    onResetLastLogin();
  }, [onResetLastLogin]);
  var handleOpenQR = useCallback(function () {
    setRoute(Route.QR);
  }, []);
  var handleOpenLogin = useCallback(function (loginConfirmation) {
    if (loginConfirmation === null || loginConfirmation === void 0 ? void 0 : loginConfirmation.enable) {
      setConfirmation(loginConfirmation);
    }

    setRoute(Route.Login);
  }, []);

  if (loading) {
    return _jsx(LoaderWrap, {
      children: _jsx(Loader, {
        color: "main"
      })
    });
  }

  return _jsxs(Root, Object.assign({
    ref: rootRef
  }, {
    children: [route !== Route.QR && !(uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.hideLogo) && _jsx(Logo, {
      variant: variant
    }), route === Route.Login && _jsx(LoginScreen, Object.assign({}, props, {
      confirmation: confirmation,
      onChangeConfirmation: handleChangeConfirmation,
      title: titleText,
      lastLoginInfo: lastLoginInfo,
      oAuthSources: oAuthSources,
      qr: qr,
      registration: registration,
      hintTooltip: hintTooltip,
      initialNotYourComputer: initialNotYourComputer,
      uiSettings: uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.login,
      getLogoutAfter: handleGetLogoutAfter,
      onLogin: handleLogin,
      onResetLastLogin: handleResetLastLogin,
      onConfirm: handleConfirm,
      onResend: authProcessor.resend,
      onRegister: handleClickRegistration,
      onClickOAuth: handleClickOAuth,
      onClickQR: handleOpenQR
    })), route === Route.Registration && _jsx(RegistrationScreen, Object.assign({}, props, {
      hintTooltip: hintTooltip,
      uiSettings: uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.registration,
      initialData: registrationData,
      onCheckRegistration: authProcessor.checkRegistration,
      onRegister: authProcessor.register,
      onConfirm: authProcessor.registrationConfirm,
      onWatch: authProcessor.registrationWatch,
      onResend: authProcessor.requestRegistrationConfirmation,
      onLogin: handleLogin,
      onClose: handleOpenLogin
    })), route === Route.QR && _jsx(QRScreen, {
      provider: props.provider.id,
      onGetQRCode: authProcessor.getQRCode,
      onAuthByQr: authProcessor.authByQRSession,
      onClose: handleOpenLogin
    }), route === Route.OAuthSelect && _jsxs(_Fragment, {
      children: [_jsx(OAuthButton, Object.assign({
        onClick: handleClickHasAccount
      }, {
        children: i18n('oAuth.hasAccount')
      })), registration && _jsx(OAuthButton, Object.assign({
        onClick: handleClickRegistration
      }, {
        children: i18n('oAuth.registration')
      }))]
    })]
  }));
};

export default Auth;